export const CountryCode = {
  FR: 'FR',
  US: 'US',
  GB: 'GB',
} as const;

export type CountryCode = (typeof CountryCode)[keyof typeof CountryCode];
